(function(window, document, jQuery) {
    if (!jQuery) {
        console.error('jQuery is not loaded');
        return;
    }

    var jhPrint = {
        // Initialize the print functionality
        init: function() {

            // Use event delegation to handle dynamically added elements
            jQuery(document).on('click', '#share-print', function() {
                window.print(); // Trigger the print dialog
                return false;
            });

            // Add beforeprint and afterprint event listeners
            window.addEventListener('beforeprint', function() {
                // Lazy load images
                jQuery('img[data-src]').each(function() {
                    var $img = jQuery(this);
                    $img.attr('src', $img.data('src'));
                    $img.removeAttr('data-src');
                });

                // Apply custom print styles
                jQuery('body').addClass('print-mode');
            });

            window.addEventListener('afterprint', function() {
                // Remove custom print styles
                jQuery('body').removeClass('print-mode');
            });
        }
    };

    // Initialize the print functionality when the document is ready
    jQuery(document).ready(function() {
        jhPrint.init();
    });
})(window, document, jQuery);